import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import LoadingBar, { ILoadingBarRef } from "./loading-bar";

export interface ILoadingWithOverlayWindowRef {
  close(): void;
  show(): void;
}

interface IProps {}

export const LoadingWithOverlayWindow = forwardRef(
  (
    {}: IProps,
    ref: React.ForwardedRef<ILoadingWithOverlayWindowRef>
  ): React.ReactElement<IProps> => {
    const loadingBarRef = useRef<ILoadingBarRef>(null);
    const [active, setActive] = useState(false);

    useImperativeHandle(
      ref,
      () => ({
        close() {
          loadingBarRef.current?.finish();
          setActive(false);
        },
        show() {
          loadingBarRef.current?.start();
          setActive(true);
        },
      }),
      [active, loadingBarRef.current]
    );

    return <LoadingBar ref={loadingBarRef} />;
  }
);

export default LoadingWithOverlayWindow;
